import css from '../tpl-css/style-section-text-with-icon.js';
import containerFuild from '../html-snippets/container-fuild';

const html = `
<div data-use-custom-width="true" data-custom-width="1204" class="container" data-attribute="container-content" style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="false" data-attribute="title-card" class="title-card" style="display: none;"></div>
    <div data-col-perview="4" data-bg-icon="#003568" data-attribute="list-item" class="wrap-items"
      style="--col-perview: 4; --bg-icon: #003568;">
      <div data-attribute="item" class="item-icon-with-text">
        <div data-attribute="icon-item" class="icon-item" style="background-color: #003568;">
          <img data-attribute="icon-image"
            src="https://cdn.skyfastimg.com/6887276edd43450009061ee3/2026/04/17/image-69e19dd0f2cfba7ad96e5a5b.png"
            alt="" />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3><span style="color:#404040;">Moves With You</span></h3>
          <p><span style="color:#404040;">Stretch that follows your body, not fights it.</span></p>
        </div>
      </div>

      <div data-attribute="item" class="item-icon-with-text">
        <div data-attribute="icon-item" class="icon-item" style="background-color: #003568;">
          <img data-attribute="icon-image"
            src="https://cdn.skyfastimg.com/68c38548e3a3f200096824cb/2026/04/22/image-69e83378165c395e1c803ff8.png"
            alt="" />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>
            <span style="color:#404040;"><strong>Feels Light</strong></span>
          </h3>
          <p><span style="color:#404040;">Soft fabric you can wear all day without noticing.</span></p>
        </div>
      </div>

      <div data-attribute="item" class="item-icon-with-text">
        <div data-attribute="icon-item" class="icon-item" style="background-color: #003568;">
          <img data-attribute="icon-image"
            src="https://cdn.skyfastimg.com/68c38548e3a3f200096824cb/2026/04/22/image-69e833832f971fbd80950051.png"
            alt="" />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>
            <span style="color:#404040;"><strong>Clean Look</strong></span>
          </h3>
          <p><span style="color:#404040;">Simple enough to wear anywhere, anytime.</span></p>
        </div>
      </div>

      <div data-attribute="item" class="item-icon-with-text">
        <div data-attribute="icon-item" class="icon-item" style="background-color: #003568;">
          <img data-attribute="icon-image"
            src="https://cdn.skyfastimg.com/68c38548e3a3f200096824cb/2026/04/22/image-69e8338f794ffb0e78fa0cf9.png"
            alt="" />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>
            <span style="color:#404040;"><strong>Stays Put</strong></span>
          </h3>
          <p><span style="color:#404040;">No pulling. No fixing. Just consistent comfort.</span></p>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
